import { useState } from "react";
import { toast } from "react-toastify";

import { getTotpSecret, enrollTotp } from "../../../services/api/factorApi";
import { useHistory } from "react-router-dom";
import { useFactors } from "../../../contexts/FactorsContext";
import { runApi } from "../../../services/api/ApiContext";
import {
  AuthBack,
  AuthBox,
  AuthButton,
  AuthContent,
  AuthIcon,
  AuthIntro,
  AuthQr,
} from "../../common/AuthBox";
import IconUser from "../../../../images/icon_user.png";
import GAIcon from "../../../../images/icon_GA.png";
import { CBTextBox } from "../../common/ContentBox";
import { toDataURL } from "qrcode";

const OktaEnrollTotp = () => {
  const [enrollStep, setEnrollStep] = useState(1);
  const [sharedSecret, setSharedSecret] = useState(null);
  const [passCode, setPassCode] = useState(null);
  const [qrCodeBody, setQrCodeBody] = useState(null);
  //const [factorId, setFactorId] = useState(null);
  const [issuer, setIssuer] = useState(null);
  const [barCodePage, setBarCodePage] = useState(true);

  const history = useHistory();
  const { refresh } = useFactors();

  const getSecret = async () => {
    const getSecretResponse = await runApi("getTotpSecret", () =>
      getTotpSecret()
    );

    if (!getSecretResponse?.data?.status) {
      return;
    }

    const otpContent = new URL(getSecretResponse.data.data.otpContent);
    const secret = otpContent.searchParams.get("secret");
    const issuer = otpContent.searchParams.get("issuer");
    setSharedSecret(secret);
    setIssuer(issuer);
    const qr = await toDataURL(otpContent.toString());
    setQrCodeBody(qr);
  };

  const toActivate = () => {
    setEnrollStep(3);
  };
  const toStep2 = () => {
    getSecret();

    setEnrollStep(2);
  };
  const activate = async () => {
    // console.log(issuer, sharedSecret);
    const activateTotpAuthResponse = await runApi("enrollTotpAuth", () =>
      enrollTotp(issuer, sharedSecret, passCode)
    );
    if (!activateTotpAuthResponse?.data?.status) {
      return;
    }
    toast.success("Activate CityU Authenticator successfully.");
    finishActivate();
  };

  const finishActivate = () => {
    refresh();
    history.push("/profile/mfa");
  };

  return (
    <AuthBox>
      <AuthIcon src={enrollStep === 1 ? IconUser : GAIcon} />
      {enrollStep === 1 && (
        <AuthIntro
          Title={"CityU Authenticator"}
          Description={"Enter single-use code from the mobile app."}
          Icon={GAIcon}
          nextEvent={() => toStep2()}
        />
      )}

      {enrollStep === 2 && (
        <AuthContent>
          <p>
            <strong>Setup CityU Authenticator</strong>
          </p>

          <AuthQr
            style={{ display: barCodePage ? "block" : "none" }}
            displayText={"Scan barcode"}
            src={qrCodeBody}
            noBarCodeEvent={() => setBarCodePage(false)}
          />

          <div style={{ display: barCodePage ? "none" : "block" }}>
            <p>Can't scan barcode?</p>
            <p>
              To set up manually enter your Account username and then input the
              following in the Secret Key Field
            </p>
            <form className="enter-code">
              <CBTextBox disabled value={sharedSecret}></CBTextBox>
            </form>
          </div>
          <AuthButton buttonEvent={() => toActivate()} buttonText={"Next"} />
          <AuthBack src="/profile/mfa/enroll/CUSTOM/token:hotp" />
        </AuthContent>
      )}

      {enrollStep === 3 && (
        <AuthContent>
          <p>
            <strong>Set up multifactor authentication</strong>
          </p>
          <p>Enter Code displayed from the application</p>
          <form className="enter-code">
            <label>Enter Code</label>
            <CBTextBox
              disabled={false}
              value={passCode}
              onChange={(e) => setPassCode(e.target.value)}
            ></CBTextBox>
          </form>

          <AuthButton buttonEvent={() => activate()} buttonText={"Verify"} />
          <AuthBack src="/profile/mfa/enroll/CUSTOM/token:hotp" />
        </AuthContent>
      )}

      {/*{enrollStep === 4 && <AuthContent></AuthContent>}*/}
    </AuthBox>
  );
};

export default OktaEnrollTotp;
